import _ from 'lodash'
import { MutationTree } from 'vuex'
import {
  GroupFormationState,
  AssignmentStatus,
} from '@/store/groups/formation/types';

const mutations: MutationTree<GroupFormationState> = {
  /**
   * グループのアサイン情報を設定
   * @param {AssignmentStatus[]} assignments グループアサイン情報
   */
  fetchedGroupAssignments: (state, assignments: AssignmentStatus[]) => {
    state.assignments = assignments
  },
};

export default mutations;
